import type {SyncIntegration} from '@cohort/merchants/apps';
import YoutubeSyncConfigComponent from '@cohort/merchants/apps/youtube/sync/SyncConfigComponent';
import type {YoutubeSyncStruct} from '@cohort/shared/apps/youtube/sync';
import {YoutubeSyncSpec} from '@cohort/shared/apps/youtube/sync';

export const YoutubeSyncIntegration: SyncIntegration<YoutubeSyncStruct> = {
  spec: YoutubeSyncSpec,
  syncConfigComponent: YoutubeSyncConfigComponent,
};
